import React, { useEffect, useState } from 'react'
import useBookingApi from '../../../../config/hooks/api/booking/useBookingApi'
import { useDispatch, useSelector } from 'react-redux'
import { setAppLoading, setMessage } from '../../../../store/common/generalSlice'
import { Card, Col, Pagination, Row } from 'antd'
import { FaChevronLeft, FaReply } from 'react-icons/fa'
import { Link, useParams } from 'react-router-dom'
import Button from '../../../../components/FormElements/Button'
import useWindowSize from '../../../../config/hooks/utility/useWindowSize'
import Modal from '../../../../components/Modal'
import ReviewContent from './ReviewContent'
import AddReviewResponse from './AddReviewResponse'
import ReviewResponse from './ReviewResponse'
import './style.css'


const ReceivedReviews = ({ title = true, spIdProp = null }) => {
  const dispatch = useDispatch()
  const { spId } = useParams()
  const { width } = useWindowSize();
  const { getReceivedUserReviews, replyToUserReview } = useBookingApi()
  const { loggedInUser } = useSelector(state => state?.auth)

  const [reviews, setReviews] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [selectedReview, setSelectedReview] = useState(null)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(5)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0)
  const [refresh, setRefresh] = useState(false)

  const providerId = (!spId && !spIdProp) ? loggedInUser?.id : (spId || spIdProp)

  const getMyReceivedUserReviews = async (repeat) => {
    try {
      dispatch(setAppLoading(true))
      if (!loggedInUser) return null

      const response = await getReceivedUserReviews(
        providerId, //sp user id
        pageSize, //limit
        repeat ? offset - pageSize : offset //offset
      )

      if (response) {
        setReviews(response?.data?.reviews?.rows)

        setTotalItems(response?.data?.reviews?.count)
        setOffset(offset + pageSize)
        setRefresh(false)

        dispatch(setAppLoading(false))
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }
  }

  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    setOffset((page - 1) * pageSize)
  };

  const handleReviewResponse = (reviewData) => {
    setSelectedReview(reviewData)
    setShowModal(true)
  }

  const handleProviderReply = async (reply) => {
    if (!reply) return false

    dispatch(setAppLoading(true))
    try {
      const response = await replyToUserReview({ reply, reviewId: selectedReview?.id })
      if (response) {
        setShowModal(false)
        setRefresh(true)

        dispatch(setAppLoading(false))
        dispatch(setMessage(response?.data?.message))
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }
  }

  const checkReplyEligibility = () => {
    const replier = loggedInUser?.type.toLowerCase()
    if(replier.includes('user')){
      return true
    }
    else{
      const providerId = spId || spIdProp
      return providerId == loggedInUser?.id ? true : false
    }
  }

  useEffect(() => {
    getMyReceivedUserReviews(false)
  }, [currentPage, pageSize])


  useEffect(() => {
    if (refresh) getMyReceivedUserReviews(true)
  }, [refresh])

  return (
    <Row>
      <Col span={24} className={`${title ? 'md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6' : ''}`}>
        {title ? (
          <div className='mb-4 flex justify-between items-center'>
            <h5 className='heading-5 text-slate-600 font-semibold mb-0'>Reviews</h5>
            <Link to='/' className='cursor-pointer flex items-center'>
              <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
              <small className='ml-2 font-medium'>Back</small>
            </Link>
          </div>
        ) : ''}
        <Row>
          <Col span={24} className={`${!title && 'mt-2'}`}>
            {reviews?.length ? reviews.map((review, index) => (
              <Card bordered={false} className={`mb-4 ${spId && 'custom-shadow'}`} key={'review' + index}>
                <div className='flex justify-between'>
                  <div className='sm:items-center'>
                    <ReviewContent data={review} />
                  </div>
                  {/* user can reply to its received reviews only*/}
                  { spId == loggedInUser?.id ? (
                    <div className='flex'>
                      <div className="w-full">
                        <Button.Basic
                          onClick={() => handleReviewResponse(review)}
                          disabled={checkReplyEligibility() || review?.reply}
                          icon={null}
                          loading={false}
                          type="primary"
                          size='medium'
                          text='Reply'
                          className='sm:block hidden btn-primary sm:w-fit w-full'
                        />
                        <FaReply
                          className={`p-1 text-4xl rounded-md ${review?.reply ? 'pointer-events-none bg-gray-100' : 'bg-primary'} text-white sm:hidden block`}
                          onClick={() => handleReviewResponse(review)}
                        />
                      </div>
                    </div>
                  ) : null }
                </div>
                {review?.reply && (
                  <div className='border-t ml-[70px] pt-2'>
                    <ReviewResponse replyData={{ reply:review?.reply, providerId }} />
                  </div>
                )}
              </Card>
            )) : 'No reviews available'}
          </Col>
          <Col span={24}>
            <div className='px-2 py-4 bg-white rounded-md'>
              <Pagination
                defaultPageSize={5}
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
                current={currentPage}
                total={totalItems}
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 20, 50]}
                onChange={onPageChange}
              />
            </div>

            <Modal.Basic
              open={showModal}
              onCancel={() => setShowModal(false)}
              width={width > 767 ? 500 : '100%'}
              maskClosable={false}
            >
              <AddReviewResponse
                data={selectedReview}
                response={handleProviderReply}
              />
            </Modal.Basic>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ReceivedReviews

